import {useParams} from 'react-router-dom'

import {useGetRequest} from 'modules/request'
import {useGetVariationRequest} from 'modules/request/api.variation'

import {Loader} from 'common/components'
import {
  ProjectScheduleStats,
  ProjectScheduleList,
  useGetProjectSchedule,
  useGetProject,
} from '..'

interface ProjectScheduleProps {
  isRequest?: boolean
  tag?: 'variation'
}

export default function ProjectSchedule({
  isRequest = false,
  tag
}: ProjectScheduleProps) {
  const params = useParams()
  const {data: loanRequest} = useGetRequest(params.uuid, isRequest && !tag)
  const {data: variRequest} = useGetVariationRequest(params.uuid, isRequest && (tag === 'variation'))

  const request = loanRequest || variRequest
  const projectUuid = isRequest ? request.project.uuid : params.uuid
  const {data: project} = useGetProject(projectUuid)
  const {data: schedule} = useGetProjectSchedule(
    (tag === 'variation') ? request?.uuid : projectUuid,
    (tag === 'variation')
  )

  if (!schedule || !project) return <Loader />

  return (
    <div>
      <ProjectScheduleStats
        project={project}
        schedule={schedule}
      />
      <ProjectScheduleList
        request={request}
        project={project}
        schedule={schedule}
      />
    </div>
  )
}
